/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum StepType {
    DEFAULT = 0,
    START = 1,
    STOP = 2,
    CONDITIONAL = 3,
    CONDITIONAL_MERGE = 4,
    PARALLEL = 5,
    PARALLEL_JOIN = 6,
    POST = 7,
    SUB_PLAY = 8,
    DELAY = 9,
    NOTIFICATION = 10,
    ARTIFICIAL_INTELLIGENCE = 11,
}
